
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Mumbaitoindorecab() {



    const cardData =
    {
        keyword: ' Mumbai to Indore Cab  ',
        heading: 'Deva Cabs: Mumbai to Indore Cab  ',
        headingDescription: 'Deva Cabs offers dependable and comfortable cab services from Mumbai to Indore, ideal for long-distance travel, corporate trips, and family journeys. Covering a distance of approximately 900 km, our well-maintained vehicles—Sedans, SUVs, or Innova Crysta—ensure a smooth and relaxing ride through the heart of India. Travel with confidence thanks to experienced chauffeurs, fixed fare packages, and convenient door-to-door pickup. With 24/7 availability and transparent service, Deva Cabs makes your Mumbai to Indore cab journey safe, efficient, and enjoyable.',

        top: 'Top Places to Visit in Indore with Deva Cabs',

"topPlaces": [
  {
    "title": "Rajwada",
    "location": "Indore, Madhya Pradesh",
    "description": "The historic Holkar Palace dating back to the 18th century, Rajwada reflects Maratha architecture and royal legacy. Its grandeur includes courtyards, fountains, and balconies, making it a must-visit cultural landmark." 
  },
  {
    "title": "Lal Bagh Palace",
    "location": "Indore, Madhya Pradesh",
    "description": "A splendid Italian Renaissance‑Revival palace built by the Holkar dynasty, spread over 76 acres with ornate interiors, rose gardens, and royal memorabilia. It has recently undergone careful restoration." 
  },
  {
    "title": "Sarafa Bazaar",
    "location": "Indore, Madhya Pradesh",
    "description": "A unique day‑night market—jewellery trade by day, vibrant street‑food hub by night—offering local specialties like poha‑jalebi, bhutte ka kees, garadu, and more in a lively atmosphere." 
  },
  {
    "title": "Chappan Dukan",
    "location": "Palasia, Indore, Madhya Pradesh",
    "description": "A famed food street with 56 shops offering diverse snacks and sweets. Known for its cleanliness award and popular offerings like chaat, dosas, and local drinks." 
  },
  {
    "title": "Khajrana Ganesh Mandir",
    "location": "Khajrana, Indore, Madhya Pradesh",
    "description": "A significant temple dedicated to Lord Ganesha, built by Rani Ahilyabai Holkar. Highly revered by devotees and known for its spiritual ambiance." 
  },
  {
    "title": "Annapurna Temple",
    "location": "Indore, Madhya Pradesh",
    "description": "A beautiful temple dedicated to Goddess Annapurna (the deity of food), featuring intricate architecture. A popular site for spiritual seekers and tourists alike." 
  },
  {
    "title": "Ralamandal Wildlife Sanctuary",
    "location": "Indore, Madhya Pradesh",
    "description": "A green, 5 km² sanctuary that includes an old royal hunting lodge. It's home to deer, birds, leopards and provides serene trekking trails near the city." 
  },
  {
    "title": "Patalpani Waterfall",
    "location": "Near Indore, Madhya Pradesh",
    "description": "A scenic waterfall about 25 km from Indore, especially dramatic during monsoons. Ideal for picnics, short treks, and nature photography." 
  },
  {
    "title": "Tincha Waterfall",
    "location": "Tincha, Near Indore, Madhya Pradesh",
    "description": "Also around 20 km away, Tincha Falls is a popular monsoon destination with a 300‑ft cascade, suitable for adventure seekers and picnic-goers." 
  },
  {
    "title": "Holkar Stadium & Cricket Museum",
    "location": "Indore, Madhya Pradesh",
    "description": "A premier cricket venue with a capacity of 30,000. The newly opened MPCA Cricket Museum (from July 15, 2025) showcases over 500 artifacts including Kapil Dev’s 1983 World‑Cup statue and memorabilia of Indian legends." 
  }
],



 "services": [
    {
      "name": "Mumbai to Indore Cab",
      "description": "Travel comfortably and conveniently with our reliable Mumbai to Indore cab services. Whether you need a one-way taxi or a round trip, we offer a wide range of vehicles including SUVs, luxury cars, and AC cabs to suit your preferences and group size. Our chauffeur-driven taxis ensure a safe, stress-free journey across this long-distance route, perfect for business trips, family visits, or leisure travel. Benefit from online booking with instant confirmation, competitive pricing, and professional drivers who prioritize your comfort and timely arrival."
    },
    {
      "name": "One-way taxi Mumbai to Indore",
      "description": "Planning a one-way trip from Mumbai to Indore? Our one-way taxi service offers flexible timings, well-maintained vehicles, and courteous drivers to make your journey smooth and hassle-free. Choose from economy to premium vehicles, all equipped with AC for your comfort. Ideal for quick business trips, personal travel, or airport transfers, our one-way cab ensures reliable service and door-to-door convenience."
    },
    {
      "name": "Book Indore cab from Mumbai",
      "description": "Booking an Indore cab from Mumbai has never been easier. Use our user-friendly online platform to reserve your vehicle in advance with instant confirmation. We offer a diverse fleet including SUVs, sedans, and luxury cars with professional chauffeurs who ensure safety and excellent customer service. Perfect for outstation trips, family vacations, or corporate travel, our booking system is designed to offer you transparency, affordable pricing, and peace of mind."
    },
    {
      "name": "SUV cab Mumbai to Indore",
      "description": "Travel in style and comfort with our SUV cab service from Mumbai to Indore. Our spacious SUVs are perfect for families or groups requiring extra luggage space and comfort during long journeys. Equipped with air conditioning and modern amenities, these vehicles provide a smooth and safe ride. Experienced chauffeurs are well-versed with the route and ensure timely pickups and drop-offs."
    },
    {
      "name": "AC cab hire Mumbai to Indore",
      "description": "Beat the heat and travel comfortably with our fully air-conditioned cab service from Mumbai to Indore. Whether it’s a daytime journey or an overnight trip, our AC cabs guarantee a pleasant environment throughout your travel. Choose from various vehicle types and enjoy professional driving service that prioritizes your convenience, safety, and satisfaction."
    },
    {
      "name": "Luxury taxi Mumbai to Indore",
      "description": "Experience premium travel with our luxury taxi options from Mumbai to Indore. Featuring high-end sedans and SUVs with plush interiors, advanced climate control, and entertainment features, these taxis cater to executives, VIPs, and travelers seeking an elevated journey. Our chauffeurs maintain utmost professionalism and discretion, ensuring a seamless, luxurious travel experience."
    },
    {
      "name": "Round trip Indore cab Mumbai",
      "description": "Plan your round trip to Indore from Mumbai with ease using our reliable cab services. Our round trip packages offer cost-effective pricing, flexible scheduling, and the convenience of a dedicated vehicle and driver for the entire journey. Perfect for business travelers, tourists, or families, this service provides door-to-door transport with multiple stops if required, ensuring a hassle-free experience."
    },
    {
      "name": "Online Mumbai to Indore taxi booking",
      "description": "Our easy-to-use online taxi booking system allows you to reserve your Mumbai to Indore cab in just a few clicks. With instant confirmation, transparent pricing, and multiple vehicle options, you can customize your ride according to your preferences and budget. Enjoy a smooth booking process backed by dedicated customer support and timely vehicle availability."
    },
    {
      "name": "Chauffeur-driven cab to Indore from Mumbai",
      "description": "Relax and enjoy your journey from Mumbai to Indore with our chauffeur-driven cab services. Our professional drivers are trained for safe driving, route expertise, and courteous customer service. This option is ideal for travelers who prefer to focus on work or leisure without worrying about navigation, parking, or road conditions. Enjoy a premium, stress-free travel experience with us."
    },
    {
      "name": "Long distance Mumbai to Indore cab",
      "description": "Cover the long distance between Mumbai and Indore comfortably with our specialized long-distance cab services. Our fleet includes vehicles designed for extended journeys, ensuring spacious seating, ample luggage room, and smooth rides. We provide regular vehicle maintenance and safety checks, so you can trust our service for a dependable, efficient, and enjoyable trip no matter the occasion."
    }
  ],
  "tableData": [
    ["Mumbai to Indore Cab", "-One-way taxi Mumbai to Indore"],
    ["Book Indore cab from Mumbai", "-SUV cab Mumbai to Indore"],
    ["AC cab hire Mumbai to Indore", "-Luxury taxi Mumbai to Indore"],
    ["Round trip Indore cab Mumbai", "-Online Mumbai to Indore taxi booking"],
    ["Chauffeur-driven cab to Indore from Mumbai", "-Long distance Mumbai to Indore cab"]
  ],

whychoose: [
  {
    "WhyChooseheading": "Reliable Mumbai to Indore Cab Service",
    "WhyChoosedescription": "Travel comfortably and reliably from Mumbai to Indore with our dedicated cab service. Perfect for business travelers, families, and groups, we provide punctual pickups and a smooth journey over the approximately 585 km route. Enjoy peace of mind knowing your travel is managed by professionals committed to your convenience."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles for Long-Distance Travel",
    "WhyChoosedescription": "Our fleet includes well-maintained, air-conditioned cars and SUVs offering ample legroom and luggage space to make your long journey to Indore relaxing. Whether traveling solo or in a group, you’ll experience a smooth ride with modern amenities designed for comfort during extended road trips."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Mumbai-Indore Route",
    "WhyChoosedescription": "Our professional drivers have extensive knowledge of highways and routes connecting Mumbai and Indore. Skilled in handling long-distance travel, they ensure safe, punctual, and hassle-free trips, navigating traffic, road conditions, and rest stops efficiently."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "We offer upfront, transparent pricing inclusive of tolls, fuel, and driver allowances. No hidden charges ensure you can plan your budget confidently, making our Mumbai to Indore cab service affordable and trustworthy."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Travel Plans",
    "WhyChoosedescription": "Our cabs are available around the clock to accommodate your preferred departure times. Whether you want to start early morning or late at night, we provide flexibility to suit your schedule for a seamless travel experience."
  },
  {
    "WhyChooseheading": "Easy Booking with Instant Confirmation",
    "WhyChoosedescription": "Book your Mumbai to Indore cab easily through our website or customer support and get instant confirmation. Receive detailed fare breakdowns and driver details so you can travel with confidence and clarity."
  },
  {
    "WhyChooseheading": "Safety and Well-Maintained Vehicles",
    "WhyChoosedescription": "All our vehicles undergo regular maintenance and sanitization before every trip. Equipped with seat belts, GPS tracking, and emergency kits, we prioritize your safety on this long journey."
  },
  {
    "WhyChooseheading": "Customizable Travel Packages",
    "WhyChoosedescription": "Whether you need a one-way ride, round trip, or multi-day travel plan with stops, we tailor packages to your needs. Ideal for tourists, business travelers, and groups seeking personalized service from Mumbai to Indore."
  }
]














    }








const faqData = [
  {
    question: "Can I book a cab from Mumbai to Indore with Deva Cabs?",
    answer: "Yes, Deva Cabs offers reliable and comfortable cab services from Mumbai to Indore for business, leisure, and long-distance travel."
  },
  {
    question: "How long is the journey from Mumbai to Indore by cab?",
    answer: "The journey typically takes around 9 to 11 hours depending on traffic and route."
  },
  {
    question: "What types of vehicles are available for the Mumbai to Indore route?",
    answer: "We provide a variety of vehicles including sedans, SUVs, Innova Crysta, Ertiga, and tempo travellers suitable for solo and group travel."
  },
  {
    question: "Can I book a one-way or round-trip cab from Mumbai to Indore?",
    answer: "Yes, Deva Cabs offers both one-way and round-trip cab services tailored to your travel needs."
  },
  {
    question: "Are tolls, parking, and driver charges included in the fare?",
    answer: "Tolls, parking, and driver allowances are additional charges that will be communicated upfront during booking."
  },
  {
    question: "Is the Mumbai to Indore cab service available 24/7?",
    answer: "Yes, Deva Cabs operates round-the-clock to accommodate your preferred travel time."
  },
  {
    question: "Is it safe to travel long distances with Deva Cabs?",
    answer: "Absolutely. Our drivers are experienced, background-verified, and trained for long-distance journeys."
  },
  {
    question: "Can I customize my itinerary or make stops during the trip?",
    answer: "Yes, customized routes and stops can be arranged based on your preferences."
  },
  {
    question: "Is this service suitable for families and groups?",
    answer: "Yes, we offer vehicles that comfortably accommodate families and groups of all sizes."
  },
  {
    question: "Why choose Deva Cabs for Mumbai to Indore cab service?",
    answer: "Deva Cabs provides clean vehicles, professional drivers, transparent pricing, and dependable service for a hassle-free journey."
  }
];

const testimonialData = [
  {
    id: 57,
    name: 'Mr. Rajesh Sharma',
    role: 'Business Traveler',
    review: 'Deva Cabs made my long trip from Mumbai to Indore comfortable and hassle-free. The driver was punctual and courteous.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 58,
    name: 'Ms. Kavita Joshi',
    role: 'Family Traveler',
    review: 'Our family trip from Mumbai to Indore was smooth thanks to Deva Cabs. The vehicle was spacious and the service excellent.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];













































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Indore Cab",
  "image": "https://devacab.com/assets/images/mumbai-to-indore-cab.jpg", // Replace with actual image URL
  "description": "Book Mumbai to Indore cab with Deva Cabs. Reliable one-way and round-trip taxi service with options including AC, SUV, luxury, and chauffeur-driven cabs. Ideal for long-distance travel.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "812"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12400",
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/mumbai-to-indore-cab" // Replace with actual page URL
  }
};






    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Mumbai to Indore Cab | Long Distance Taxi from Mumbai | Deva Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Indore cab with Deva Cabs. Comfortable and affordable one-way or round trip cab service. Options include AC, SUV, luxury, and chauffeur-driven cars. Ideal for long-distance intercity travel." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Indore Cab, One-way taxi Mumbai to Indore, Book Indore cab from Mumbai, SUV cab Mumbai to Indore, AC cab hire Mumbai to Indore, Luxury taxi Mumbai to Indore, Round trip Indore cab Mumbai, Online Mumbai to Indore taxi booking, Chauffeur-driven cab to Indore from Mumbai, Long distance Mumbai to Indore cab" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/37.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Mumbaitoindorecab;